import type { FaireProductEntity } from "../../entity_types/product";

export const p_7d8fb3c8wh: FaireProductEntity = {
  token: "p_7d8fb3c8wh",
  type: "product",
  name: "20\" x 20\" Folding Light Box with Dual-Sided Backdrops",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/0bfeefa908ad9800e22379165316db533e6ed933728daff14dfe66ccf6c576c8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8644eabcaca2c617b35d28aa89833f0920ca220c515cc6ae35dd6a3c92500fca.jpeg",
    "https://cdn.faire.com/fastly/d0c19979061b11314c19d4e7a656513a1ae99a7325478f4ca664cf4b1406dbd9.jpeg",
    "https://cdn.faire.com/fastly/7e68bb11d5bd94577323ff38cdbb124dfabb74f1299067fca83f7600184a38b2.jpeg",
    "https://cdn.faire.com/fastly/68333435e63b7248e02c897920f9ae2c7a120262bf3c403d088711b7404ba51c.jpeg",
    "https://cdn.faire.com/fastly/0e6c380d6e491233b11b1ddb21776d543e34cf68cdd61a7567121045241c4c38.jpeg",
    "https://cdn.faire.com/fastly/06d80602e526fb8a2fa7771bf88ac574ddd7bb7f2add4a0ca41b2689cce28500.jpeg",
    "https://cdn.faire.com/fastly/f6e6c758181c9466bec8eb1b27c9ee4d5bdb80eaa7882b1bfd760ddb1327822d.jpeg",
    "https://cdn.faire.com/fastly/db09cd4210036c193e9412793786d8ab3c3a08974e5afa79894cb02c1add2bf8.jpeg",
    "https://cdn.faire.com/fastly/9cb94b68a69c2981f14eccccb2272953ab8223da4a4709d536b03047e502f867.jpeg"
  ],
  priceDollars: 59.99,
  description: "A roomy 20\" x 20\" folding light box for photographing small to medium merchandise. The enclosed design helps create even lighting with fewer harsh shadows for clean, consistent product images.\n\n- Size: 20\" x 20\"\n- Includes dual-sided backdrops for flexible background choices\n- Folds for easy setup, transport and storage\n\nIdeal for boutiques and online sellers shooting jewelry, accessories, gifts and collectibles for listings, catalogs and marketing.",
  tags: [],
  msrpDollars: 89.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:16.460Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
